/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import axios from 'axios'
import { concatFullName } from '../../libs/utils'
import { apiURL, prsCodes } from '../../libs/utils/api'

const initialState = {
  isAuthenticated: false,
  msgText: '',
  msgTitle: '',
  loginInfo: {
    email: '',
    fullName: '',
    redirectUrl: '',
  },
  loginError: null,
}

export const loginWithOTP = createAsyncThunk('login/userLogin', async (data, { dispatch }) => {
  try {
    const res = await axios.post(`${apiURL}`, {
      ...data,
      prsCode: prsCodes.loginWithOtp,
    })
    const {
      data: { responsePayload: loginRes },
    } = res

    if (loginRes.statusCode !== 200) {
      return dispatch(
        loginFailure({
          name: 'login failed',
          message: `reason: ${loginRes.msgText}`,
        })
      )
    }
    return dispatch(loginSuccess(loginRes))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    const errorBlob = {
      name: e.name,
      message: e.message,
    }
    return dispatch(loginFailure(errorBlob))
  }
})

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginSuccess: (state, { payload: { statusCode, redirectUrl, email, firstName, lastName } }) => {
      state.isAuthenticated = statusCode === 200
      state.redirectUrl = statusCode === 302 ? redirectUrl : ''
      state.loginInfo = {
        email,
        fullName: concatFullName(firstName, lastName),
      }
      state.loginError = null
    },
    loginFailure: (state, { payload }) => {
      state.loginError = payload
      state.isAuthenticated = false
      Object.entries(state.loginInfo).forEach(([k, _v]) => {
        state.loginInfo[k] = ''
      })
      state.redirectUrl = ''
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.redirectUrl = ''
    },
  },
})

export const { logout, loginSuccess, loginFailure } = loginSlice.actions

const selectIsAuthenticated = (state) => state.login.isAuthenticated
const selectLoginError = (state) => state.login.loginError
const selectLoginInfo = (state) => state.login.loginInfo
export const selectLoginBlob = createSelector(
  selectIsAuthenticated,
  selectLoginInfo,
  selectLoginError,
  (isAuthenticated, { fullName, email, redirectUrl }, loginError) => ({
    isAuthenticated,
    fullName,
    email,
    loginError,
  })
)

export default loginSlice.reducer
